import { NgModule } from '@angular/core';
import { IMASK_FACTORY } from 'angular-imask';
import { FormFieldsModule } from '../form-fields.module';
import { MockIMaskFactory } from './imask.mock';

@NgModule({
  imports: [FormFieldsModule.forRoot({ apiKey: 'test' })],
  exports: [FormFieldsModule],
  providers: [{ provide: IMASK_FACTORY, useClass: MockIMaskFactory }],
})
export class FormFieldsTestingModule {}
